import { render } from "./ValidityPurchaseOptionsSettings.vue?vue&type=template&id=28a5c8df"
import script from "./ValidityPurchaseOptionsSettings.vue?vue&type=script&lang=js"
export * from "./ValidityPurchaseOptionsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__